import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { AppHttpClient } from "src/app/core-features/auth-guard/http-client.service";
import { environment } from "src/environments/environment";
@Injectable()
export class LayoutService {
  public domain = environment.CORE_LINK;
  public _comp1ValueBS: Subject<any> = new Subject();
  constructor(private http: AppHttpClient) {}

  public project$: Subject<any> = new Subject();
  public dashboardReload: Subject<any> = new Subject<any>();
  public templatesReload: Subject<any> = new Subject<any>();
  public thingsReload: Subject<any> = new Subject<any>();
  public dashboardReloadListener() {
    return this.dashboardReload.asObservable();
  }
  public templatesReloadListener() {
    return this.templatesReload.asObservable();
  }
  public thingsReloadListener() {
    return this.thingsReload.asObservable();
  }

  public updateComp1Val(val) {
    this._comp1ValueBS.next(val);
  }
  private urls = {
    //alertUrl: `${this.domain}/api/v2/notifications/query`,
    alertUrl: `${this.domain}/api/v2/notifications/query`,
    projectUrl: `${this.domain}/api/v2/projects`
  };

  getAllProject() {
    return this.http.get(this.urls.projectUrl);
  }
  getAllAlertLevel(action, name, value) {
    let body = {
      query: [
        {
          action: "$" + action,
          name: name,
          value: value
        }
      ]
    };
    return this.http.post(this.urls.alertUrl, body);
  }
}
